import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./routes/route";
import "./App.scss";
import "./Responsive.scss";
import { ToastContainer } from "react-toastify";
import { SocketProvider } from "./context/SocketContext";
import PortraitStage from "./compoment/PortraitStage";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";

registerServiceWorker();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const stripEnvQuotes = (value: string | undefined) =>
  (value || "").trim().replace(/^['"]|['"]$/g, "");

const socketSecretKey = stripEnvQuotes(
  process.env.REACT_APP_MAKE_A_WISH_SECRET_KEY ||
    process.env.REACT_APP_WANT_RIVER_SECRET_KEY
);
const paymentSocketSecretKey = stripEnvQuotes(
  process.env.REACT_APP_KIOSK_SECRET_KEY ||
    process.env.REACT_PUBLIC_KIOSK_SECRET_KEY
);

root.render(
  <React.StrictMode>
    <SocketProvider
      secretKey={socketSecretKey}
      paymentSecretKey={paymentSocketSecretKey}
    >
      <PortraitStage>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover={false}
          theme="dark"
        />
        <div className="portraitPage">
          <AppRoutes />
        </div>
      </PortraitStage>
    </SocketProvider>
  </React.StrictMode>
);
